import React, { FC } from "react";

interface ReviewCategoryProps {
  title: string;
  rating: number;
  setRating: (value: React.SetStateAction<number>) => void;
}
const ReviewCategory: FC<ReviewCategoryProps> = ({
  title,
  rating,
  setRating,
}) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <p className=" font-Poppins text-base font-medium">{title}</p>
      <div className=" flex gap-1 items-center">
        {new Array(5).fill(null).map((_, index) => (
          <div
            key={index}
            className="cursor-pointer"
            onClick={() => {
              setRating(index + 1); // console.log("clicked");
            }}
          >
            {/* Display a filled star if the index is less than the rating, otherwise, display an empty star */}
            <svg
              width="20"
              height="20"
              viewBox="0 0 72 73"
              fill={index < rating ? "#FABF35" : "#D1D1D1"}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M35.999 52.1765L48.449 59.7065C50.729 61.0865 53.519 59.0465 52.919 56.4665L49.619 42.3065L60.629 32.7665C62.639 31.0265 61.559 27.7265 58.919 27.5165L44.429 26.2865L38.759 12.9065C37.739 10.4765 34.259 10.4765 33.239 12.9065L27.569 26.2565L13.079 27.4865C10.439 27.6965 9.359 30.9965 11.369 32.7365L22.379 42.2765L19.079 56.4365C18.479 59.0165 21.269 61.0565 23.549 59.6765L35.999 52.1765Z"
                fill={index < rating ? "#FABF35" : "#D1D1D1"}
              />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewCategory;
